export default __webpack_public_path__ + "3c581482b4ac36706f5659da9029b064.png";